import * as React from 'react';
import { constants } from '@thecb/components';

export const OpenedIcon = () => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{'8F2BBA62-927B-4722-8677-5D29EB99E767@1x'}</title>
      <path
        d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm6 9H10a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V10a1 1 0 00-1-1zm-.5 1.5v11h-11v-11h11z"
        fill={constants.colors.LUCKY_POINT}
        fillRule="evenodd"
      />
    </svg>
  );
};
